import HttpClient from "../../../../core/HttpClient";
import { Authentication } from "@leedpulse-monorepo/classes";

export interface ContactsQueueStats {
    /** Contacts en attente de traitement dans `ContactsQueue`. */
    pending: number;
    /** Contacts en échec (statuts `failed` et `error` confondus). */
    failed: number;
    /** `created` du plus vieux document `pending`, ou `null` si la queue est vide. */
    oldestPendingCreated: number | null;
    /** Estimation théorique basée sur la config du job (lot/minute), pas sur un débit mesuré. */
    estimatedMinutesRemaining: number;
}

const EMPTY: ContactsQueueStats = { pending: 0, failed: 0, oldestPendingCreated: null, estimatedMinutesRemaining: 0 };

/** Fetches the contacts import queue health (uncached route — see live.helpers.ts). */
async function getContactsQueueStats(auth: Authentication | null): Promise<ContactsQueueStats> {
    if (!auth) return EMPTY;

    const response = await HttpClient.post('/leedflow/contacts-queue-stats', {}, auth.token);

    if (!response || typeof (response as ContactsQueueStats).pending !== 'number') {
        throw new Error('Réponse /leedflow/contacts-queue-stats inattendue : backend non à jour ?');
    }

    return response as ContactsQueueStats;
}

export default getContactsQueueStats;
